import { render, staticRenderFns } from "./AnnualEvent.vue?vue&type=template&id=2b5563c8&scoped=true"
import script from "./AnnualEvent.vue?vue&type=script&lang=js"
export * from "./AnnualEvent.vue?vue&type=script&lang=js"
import style0 from "./AnnualEvent.vue?vue&type=style&index=0&id=2b5563c8&prod&lang=css"
import style1 from "./AnnualEvent.vue?vue&type=style&index=1&id=2b5563c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5563c8",
  null
  
)

export default component.exports